import { render, staticRenderFns } from "./EachCountryAssessmentWidget.vue?vue&type=template&id=4b9cd06f&scoped=true&"
import script from "./EachCountryAssessmentWidget.vue?vue&type=script&lang=js&"
export * from "./EachCountryAssessmentWidget.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryAssessmentWidget.vue?vue&type=style&index=0&id=4b9cd06f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9cd06f",
  null
  
)

export default component.exports